import store from "@/store/main";
import Storage from "@/utils/storage";
import { loadScript } from "@/utils/utils";
import { popupLogin } from "@central/loginer";
import "@central/loginer/style.css";
import { updateHeader } from "@picwish/header";
let modalService;
let deferer = null;

function showAccountDialog(options = {}) {
  if (!modalService) {
    return (deferer = showAccountDialog.bind(null, options));
  }
  const successCallback = options.successCallback || Function.prototype;
  delete options.successCallback;

  modalService.showModal(
    () => ({
      component: import(
        /* webpackPrefetch: true */
        /*  webpackChunkName: "Account" */
        `@/components/Account.vue`
      ),
    }),
    {
      width: "400px",
      height: "500px",
    },
    {
      successCallback: () => {
        modalService.hideModal("Account");
        modalService.$root.$emit("user:logined");
        successCallback();
      },
      ...options,
    },
    "Account"
  );
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim();
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return "";
}

export default class AccountService {
  constructor() {
    setTimeout(() => {
      const moduleLoadService = useService("ModuleLoadService");
      moduleLoadService.onLoad("modal", (m) => {
        modalService = m.default;
        modalService.$root = document.getElementById("app").__vue__;
        if (deferer) {
          deferer();
        }
      });
    });
  }
  showAccountDialog(...args) {
    return popupLogin({
      onLogin(data) {
        const { api_token, identity_token, user } = data;
        Storage.set("account_api_token", api_token);
        Storage.set("account_user", user);
        Storage.set("account_id_token", identity_token);
        store.dispatch("UpdateApiToken", api_token);
        store.dispatch("UpdateUserInfo", user);
        store.dispatch("UpdateIdentityToken", identity_token);
        typeof args[0] === "function" && args[0]();

        // 更新header状态
        updateHeader();

        setTimeout(() => {
          const el = document.querySelector(".headerUserInfo > span");
          if (el) {
            el.addEventListener("click", () => {
              store.dispatch("Logout");
            });
          }
        }, 0);

        // GA注册事件使用 by harry
        let userCreatedAt = user.created_at || 0;
        let userLastLoginTime = user.last_login_time || 0;
        // 当用户创建时间 === 最近一次登录时间 的时候，认为是新用户，需要发送注册转化事件
        if (
          userCreatedAt &&
          userLastLoginTime &&
          userCreatedAt === userLastLoginTime
        ) {
          if (document.documentElement.lang === "zh") {
            window._agl = window._agl || [];
            window._agl.push(["production", "_f7L2XwGXjyszb4d1e2oxPybgD"]);
            loadScript(
              "https://fxgate.baidu.com/angelia/fcagl.js?production=_f7L2XwGXjyszb4d1e2oxPybgD"
            ).then(() => {
              document.getElementById("baiduAgl").click();
            });
          } else {
            let event = new CustomEvent("wx_user_register_complete", {
              detail: {
                country: user.region,
                id: user.user_id,
                apptype: getCookie("apptype"),
              },
            });
            window.dispatchEvent(event);
          }
        }
      },
      onClose() {
        typeof args[1] === "function" && args[1]();
      },
      initialType:
        document.documentElement.lang === "zh" ? "free-password" : "password",
    });
  }
}
